// extracted by mini-css-extract-plugin
export var marginNegative = "_6h-5 _6h-3 _6h-1";
export var marginPositive = "_6h-4 _6h-3 _6h-1";
export var modalContent = "_6h-6";
export var samplesTable = "_6h-8";
export var samplesTableContainer = "_6h-7";
export var statBox = "_6h-a";
export var tableCell = "_6h-1";
export var tableCellCenter = "_6h-2 _6h-1";
export var tableCellRight = "_6h-3 _6h-1";
export var tableHeader = "_6h-0";
export var trackingNumber = "_6h-9";